import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../../../utility/client';

export const putUnit = async (unit: AdminTypes.UnitUpdateDto) => {
  try {
    const res = await Api.put<AdminTypes.UnitDto>(
      `/admin/v1/units/${unit.id}`,
      unit,
    );

    return res?.data;
  } catch (error) {
    console.error('error editing unit');
    throw error;
  }
};
